import FeaturedWithCarouselContent, { ESlidesMode, ISlideContent } from "@organic-return/foundation-react/src/components/Blades/FeaturedWithCarouselContent"
import { Link, graphql, useStaticQuery } from "gatsby"
import React from "react"
const FeaturedContentSlider = ({ module }) => {
  const data = useStaticQuery(graphql`
    query {
        allAgilityGenericContent {
          nodes {
            customFields {
              title
              subheader
              content
              image {
                url
              }
            }
            properties {
               referenceName
            }
            callsToAction {
              customFields {
                icon {
                  url
                }
                url {
                  href
                  text
                  target
                }
              }
            }
          }
        }
        allAgilityLinkItem {
          nodes {
            customFields {
             url{
              href	
              text
              target
             }
            }
            properties {
              referenceName
            }
          }
        }                     
    }
  `)
  const fields = module.customFields
  let slides: ISlideContent[] = []
  if (fields.slides?.referencename) {
    const genericContent = data.allAgilityGenericContent?.nodes?.filter(x => x.properties?.referenceName == fields.slides.referencename);
    slides = genericContent?.map((x: any): ISlideContent => {
      return {
        title: x.customFields.title,
        subtitle: x.customFields.subheader,
        image: { url: x.customFields.image?.url ? `${x.customFields.image?.url}?q=60&format=auto` : "" },
        content: x.customFields.content,
      }
    })
  }

  let bottomContent = <></>
  if (fields.bottomButtons?.referencename || fields.bottomText) {
    const buttons = data.allAgilityLinkItem?.nodes?.filter(x => x.properties?.referenceName == fields.bottomButtons?.referencename).map(item => (
      <a href={item.customFields.url?.href} className="inline-block text-button-text bg-button-bg border py-2 px-4">{item.customFields.url?.text}</a>
    ))
    bottomContent = (
      <div className="relative w-full inverted">
        <div className="relative w-full max-w-screen-xl mx-auto flex flex-row flex-wrap p-4">
          {fields.bottomText && (
            <div className="w-full lg:w-2/3" dangerouslySetInnerHTML={{ __html: fields.bottomText }}></div>
          )}
          {buttons && buttons.length > 0 && (
            <div className="w-full lg:w-1/3 flex flex-row justify-center items-center gap-x-12">{buttons}</div>
          )}
        </div>
      </div>
    )
  }
  return (
    <FeaturedWithCarouselContent
      containerClassName="featured-content-slider"
      slideMode={ESlidesMode.horizontal}
      showSlidePage={false}
      slides={slides}
      title={fields.title}
      secondaryTitle={fields.secondaryTitle}
      children={bottomContent}
    />
  )
}

export default FeaturedContentSlider